import { inject, Injectable } from '@angular/core';
import { EDeliverableType } from '@enums/campaign.enum';
import { IDeliverableConfig } from '../deliverable-list.interface';
import { TextDescriptionDeliverableService } from '../shared/text-description-deliverable/text-description-deliverable.service';
import { TalkingPointAiComponent } from './talking-point-ai.component';

@Injectable({
  providedIn: 'root',
})
export class TalkingPointAiService {
  private readonly textDescriptionDeliverableService = inject(TextDescriptionDeliverableService);

  public getConfig(): IDeliverableConfig {
    return this.textDescriptionDeliverableService.getConfig({
      component: TalkingPointAiComponent,
      defaultNameTranslationKey: 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.talkingPointAiDeliverable.title',
      deliverableType: EDeliverableType.talkingPointAi,
    });
  }
}
